import { createMutationHook } from "@accurx/api/QueryClient";
import { SaveRecentSearchRequest } from "@accurx/api/patient-messaging";
import { httpClient2 } from "@accurx/shared";

export const LatestPatientSearchKey = "LatestPatientSearch";

const addPatientToRecentSearches = async ({
    organisationId,
    patientToken,
}: SaveRecentSearchRequest): Promise<unknown> =>
    await httpClient2.post({
        path: "/api/patientmessaging/latestpatientsearch",
        json: {
            organisationId,
            patientToken,
        },
    });

export const useAddPatientToRecentSearches =
    createMutationHook<SaveRecentSearchRequest>(() => ({
        mutationKey: [LatestPatientSearchKey],
        mutationFn: async ({ organisationId, patientToken }) =>
            await addPatientToRecentSearches({
                organisationId,
                patientToken,
            }),
    }));
